import { CultureInfo } from '../culture-info.model';
import { CultureInfoUz } from './uz';

/**
 * @ignore
 */
export const CultureInfoUzCyrl: CultureInfo = {
  name: 'uz-Cyrl',
  displayName: 'Uzbek (Cyrillic)',
  iso3LanguageCode: 'uzb',
  iso2LanguageCode: 'uz',
  ietfLanguageTag: 'uz-Cyrl',
  parent: CultureInfoUz
};
